// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Assets/Images/search-dark.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../Assets/Images/user-active.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.industry-container {
  display: flex;
  flex-direction: column;
  border-radius: 20px;
  background-color: #fff;
}
.industry-container.inner {
  margin-bottom: 30px;
}
.industry-container.out {
  height: 95vh;
  margin: 40px auto;
  max-width: 95%;
  overflow-x: hidden;
  overflow-y: auto;
  padding-bottom: 40px;
}
.industry-container .title {
  font-family: Inter;
  font-size: 24px;
  font-weight: 600;
  line-height: 40px;
  letter-spacing: -0.02em;
  text-align: left;
}
.industry-container .select-container {
  border: 1px solid #e7ecee;
}
.industry-container .industry-select-items {
  margin-top: 20px;
  width: 446px;
}
.industry-container .industry-select-items .select-container {
  padding: 6px 6px 6px 16px;
}
.industry-container .industry-select-items-inner {
  box-shadow: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: left 8px;
  padding-left: 20px;
}
.industry-container .industry-select-items-inner.team-size-select {
  box-shadow: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: left 8px;
  padding-left: 20px;
}
.industry-container .title-container {
  width: 470px;
  margin: 0 auto;
  text-align: left;
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 30px;
  margin-top: 40px;
}
.industry-container .btn-save-industry {
  margin-top: 20px;
}
.industry-container .btn-save-industry button {
  width: 468px;
  height: 52px;
  background-color: #0084FF;
  border-radius: 12px;
  color: #ffffff;
  font-weight: 600;
}
.industry-container .btn-save-industry .disabled:hover button {
  cursor: not-allowed;
}
.industry-container .btn-skip-industry {
  cursor: pointer;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.02em;
  text-align: left;
  margin-top: 30px;
}
.industry-container .centered-industry-items {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-around;
}`, "",{"version":3,"sources":["webpack://./src/Components/IndustryAndTeamMembers/industryandteammembers.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;AACF;AACE;EACE,mBAAA;AACJ;AAEE;EACE,YAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;AAAJ;AAGE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;AADJ;AAIE;EACE,yBAAA;AAFJ;AAKE;EACE,gBAAA;EACA,YAAA;AAHJ;AAME;EACE,yBAAA;AAJJ;AAOE;EACE,gBAAA;EACA,yDAAA;EACA,4BAAA;EACA,6BAAA;EACA,kBAAA;AALJ;AAQE;EACE,gBAAA;EACA,yDAAA;EACA,4BAAA;EACA,6BAAA;EACA,kBAAA;AANJ;AASE;EACE,YAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,uBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;AAPJ;AAWE;EACE,gBAAA;AATJ;AAWI;EACE,YAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AATN;AAYI;EACE,mBAAA;AAVN;AAcE;EACE,eAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;AAZJ;AAeE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,6BAAA;AAbJ","sourcesContent":[".industry-container {\n  display: flex;\n  flex-direction: column;\n  border-radius: 20px;\n  background-color: #fff;\n\n  &.inner {\n    margin-bottom: 30px;\n  }\n\n  &.out {\n    height: 95vh;\n    margin: 40px auto;\n    max-width: 95%;\n    overflow-x: hidden;\n    overflow-y: auto;\n    padding-bottom: 40px;\n  }\n\n  .title {\n    font-family: Inter;\n    font-size: 24px;\n    font-weight: 600;\n    line-height: 40px;\n    letter-spacing: -0.02em;\n    text-align: left;\n  }\n\n  .select-container {\n    border: 1px solid #e7ecee;\n  }\n\n  .industry-select-items {\n    margin-top: 20px;\n    width: 446px;\n  }\n\n  .industry-select-items .select-container {\n    padding: 6px 6px 6px 16px;\n  }\n\n  .industry-select-items-inner {\n    box-shadow: none;\n    background-image: url(\"../../Assets/Images/search-dark.svg\");\n    background-repeat: no-repeat;\n    background-position: left 8px;\n    padding-left: 20px;\n  }\n\n  .industry-select-items-inner.team-size-select {\n    box-shadow: none;\n    background-image: url(\"../../Assets/Images/user-active.svg\");\n    background-repeat: no-repeat;\n    background-position: left 8px;\n    padding-left: 20px;\n  }\n\n  .title-container {\n    width: 470px;\n    margin: 0 auto;\n    text-align: left;\n    display: flex;\n    flex-direction: column;\n    align-content: flex-start;\n    align-items: flex-start;\n    justify-content: flex-start;\n    margin-bottom: 30px;\n    margin-top: 40px;\n  }\n\n\n  .btn-save-industry {\n    margin-top: 20px;\n\n    button {\n      width: 468px;\n      height: 52px;\n      background-color: #0084FF;\n      border-radius: 12px;\n      color: #ffffff;\n      font-weight: 600;\n    }\n\n    .disabled:hover button {\n      cursor: not-allowed;\n    }\n  }\n\n  .btn-skip-industry {\n    cursor: pointer;\n    font-family: Inter;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 24px;\n    letter-spacing: -0.02em;\n    text-align: left;\n    margin-top: 30px;\n  }\n\n  .centered-industry-items {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    justify-content: space-around;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
